<template>
  <div>
    <top></top>
    <div class="maindiv search-wrap bg-gray">
      <div class="ht15"></div>
      <div class="htmldiv bgw">
        <div class="psearch mat">
          <div class="pinput br5 prelative dinline-block bgw tleft" style="box-shadow: none;">
            <input class="ml10 input dinline-block fs18" name="" v-model="keyword" placeholder="请输入关键字搜索">
            <a class="zbtn pabsolute fs20 twhite bg-red" href="javascript:void(0);" @click="searchData">搜索</a>
          </div>
          <div class="prelative tc9 hot mt10 lh18">
            <div class="pabsolute nt">热词：</div>
            <a href="javascript:;" class="tc9 mr5 hred" v-for="keyw in hostList" @click="setKeyword(keyw)">{{keyw}}</a>
          </div>
        </div>

      </div>
      <div class="htmldiv bgw scont mt20" v-if="list.length>0">
        <search-item v-for="(item,index) in list" :item="item" :index="index" :key="item.id" :keyword="keyword"/>
        <pagec :total="total" :size="perPage" :page="page" @get-data="getData"></pagec>
      </div>

      <div class="ht30"></div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Top from '../../components/search/Top'
import Bottom from "../../components/Bottom"
import Pagec from '../../components/un_index/Page'
import SearchItem from "../../components/search/SearchItem";
export default {
  name: "index",
  components: {
    Top,
    Bottom,
    Pagec,
    SearchItem,
  },
  data () {
    return {
      keyword:'',
      total:0,
      page:1,
      perPage:10,
      hostList:[],
      list:[],
    }
  },
  mounted() {
    this.keyword = this.$route.query.keyword;
    this.getHost();
    this.getData();
  },
  methods:{
    setKeyword:function(keyword){
      this.keyword = keyword;
      this.getData(1);
    },
    getHost:function(){
      this.$request.get('article/hot-search',[],response => {
        if(response.status == 200){
          this.hostList = response.data.data;
        }
      },error => {
        console.log(error);
      })
    },
    getData:function (page) {
      this.page = page;
      if(this.keyword == '' || this.keyword == undefined){
        return false;
      }
      var getParam = {};
      getParam['search'] = this.keyword;
      getParam['perPage'] = this.perPage;
      getParam['page'] = this.page;
      this.$request.get('article/search',getParam,response => {
        if(response.status == 200){
          this.list = response.data.data.data;
          this.total = response.data.data.total;
        }
      },error => {
        console.log(error);
      })
    },
    searchData:function(){
      this.getData(1);
    },
  },
  watch:{
    keyword:{
      handler:function (n,o) {
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/search/index.vue